import { render, staticRenderFns } from "./confirmContract.vue?vue&type=template&id=0aa37192"
import script from "./confirmContract.vue?vue&type=script&lang=js"
export * from "./confirmContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports